import template from './dashboard.html';
import controller from './dashboard.controller';
import './dashboard.scss';

let dashboardComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: "vm"
};

export default dashboardComponent;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/dashboard.component.js